module.exports = __webpack_public_path__ + "img/papier-dechire-bas.2ff7403a.png";